import { getAllUsers } from '../../services/permissionManager';

export const permissionManager = {
  namespace: 'permissionManager',
  state: {
    permissions: [],
    userData: [],
    permissionWidths: [],
  },
  reducers: {
    updateUsers(state, { payload: userData }) {
      return { ...state, userData };
    },
    updatePermissionManagerWidths(state, { payload: permissionWidths }) {
      return { ...state, permissionWidths };
    },
  },
  effects: {
    *pageInit({ payload: { pathParams } }, { put }) {
      yield put({ type: 'fetchUsers' });
    },
    *fetchUsers(emptyPayload, { call, put }) {
      const response = yield call(getAllUsers);
      if (response) {
        yield put({ type: 'updateUsers', payload: response.data });
      }
    },
  },
};
